import { get } from "lodash";

const deserializeStudentDetails = (studentDetails) => {
    const lodashGet = (key, defaultValue) => get(studentDetails, key, defaultValue);

    const getFullName = () => {
        let firstName = lodashGet("first_name", "");
        let lastName = lodashGet("last_name", "");
        return `${firstName || ""} ${lastName || ""}`;
    };

    const getCRMLink = () => {
        let recordType = lodashGet("record_type", "");
        let crmId = lodashGet("crm_id", "");
        return `https://crm.zoho.com/crm/org667250420/tab/${recordType}/${crmId}`;
    };

    let data = {};
    if (studentDetails) {
        data = {
            academicDetails: lodashGet("academicDetails", []),
            testDetails: lodashGet("testDetails", []),
            backlogs: lodashGet("backlogs", 0),
            workExperience: lodashGet("workExperience", {}),
            name: getFullName(),
            crmLink: getCRMLink(),
            targetDetails: lodashGet("targetDetails", {}),
            participatingUniversities: deserializeParticipatingUniversities(
                lodashGet("participating_universities") || []
            ),
            firstName: studentDetails.first_name,
            lastName: studentDetails.last_name,
            registrantCode: studentDetails.registrant_code,
            userId: studentDetails.user_id,
            counsellorId: studentDetails.counsellor_id,
            desired_profile: studentDetails.desired_profile,
            educationHistory: studentDetails.education_history,
            testScores: studentDetails.test_scores,
            mobile: studentDetails.mobile,
            email: studentDetails.email,
            allNotes: deserializeStudentNotes(studentDetails.all_notes),
        };
    }
    return data;
};

const deserializeStudentNotes = (notes) => {
    return (notes || []).map((note) => ({
        text: get(note, "text", ""),
        universityName: get(note, "university_name", ""),
    }));
};

const deserializeParticipatingUniversities = (participatingUniversities) => {
    participatingUniversities.sort((x, y) => {
        if (x.attendance) return -1;
        if (y.attendance) return 1;
        if (x.must_visit) return -1;
        if (y.must_visit) return 1;
        return 0;
    });

    return participatingUniversities || [];
};

export { deserializeStudentDetails, deserializeStudentNotes, deserializeParticipatingUniversities };
